import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { API_BASE_URL } from './api.config';
import { unwrapPagedList } from './paged-list';
import { VesselAnnouncement, VesselAnnouncementListItem, VesselAnnouncementSearchRequest } from '../../shared/models/vessel-announcement';

@Injectable({ providedIn: 'root' })
export class VesselAnnouncementService {
  constructor(private readonly http: HttpClient) {}

  search(request: VesselAnnouncementSearchRequest = { Page: 1, PageSize: 50 }) {
    return this.http.post<unknown>(`${API_BASE_URL}/mobile/VesselAnnouncementListSearch`, request).pipe(
      map(raw => unwrapPagedList<VesselAnnouncementListItem>(raw))
    );
  }

  get(id: string | number) {
    return this.http.get<VesselAnnouncement>(`${API_BASE_URL}/mobile/GetVesselAnnouncement/${encodeURIComponent(String(id))}`);
  }
}
